module.exports = __webpack_public_path__ + "img/kjLogo.c3f5a9c2.png";